if (!customElements.get('bstore-custom-badge')) {
  customElements.define('bstore-custom-badge', class extends HTMLElement {
    connectedCallback() {
      this.scheduleFit = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.fitText());
      };
      this.resizeObserver = new ResizeObserver(this.scheduleFit);
      this.resizeObserver.observe(this);
      this.textObserver = new MutationObserver(this.scheduleFit);
      this.textObserver.observe(this, {childList: true, characterData: true, subtree: true});
      this.scheduleFit();
      document.fonts.ready.then(() => { if (this.isConnected) this.scheduleFit(); });
    }
    disconnectedCallback() {
      this.resizeObserver.disconnect();
      this.textObserver.disconnect();
      cancelAnimationFrame(this.frame);
    }
    fitText() {
      const layout = this.querySelector('.bstore-promo-custom-layout');
      if (!layout || !this.clientWidth) return;
      const style = getComputedStyle(this);
      const height = this.clientHeight - parseFloat(style.paddingTop) - parseFloat(style.paddingBottom);
      const width = this.clientWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight);
      const fits = scale => {
        this.style.setProperty('--bstore-custom-fit', scale);
        return layout.scrollHeight <= height && layout.scrollWidth <= width;
      };
      if (fits(1)) return;
      let low = 0.1;
      let high = 1;
      for (let i = 0; i < 12; i++) {
        const mid = (low + high) / 2;
        if (fits(mid)) low = mid;
        else high = mid;
      }
      fits(low);
    }
  });
}
